import script from "./ProductTourHost.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTourHost.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__